import { Record } from 'immutable';
import { AdjustmentType } from '../adjustment-type';

const AdjustmentSummaryRecord = Record({

  eventAdjustmentId: null,
  /**
   * Total Spend in the payment summary card does not consider if shoulder dates should be excluded.
   */
  totalSpend: null,
  /**
   * Comm Rate in the payment summary card is the commission percentage
   */
  commRate: null,
  /**
   * The result of applying the commission percentage to the commissionable revenue.
   * In the case of reservations and RSVPs, it considers if shoulder dates should be excluded.
   */
  amountDue: null,

  adjustmentType: null,
  description: null
});

export class AdjustmentSummary extends AdjustmentSummaryRecord {

  eventAdjustmentId: number;

  /**
   * Total Spend in the payment summary card does not consider if shoulder dates should be excluded.
   */
  totalSpend: number;
  /**
   * Comm Rate in the payment summary card is the commission percentage
   */
  commRate: number;
  /**
   * The result of applying the commission percentage to the commissionable revenue.
   * In the case of reservations and RSVPs, it considers if shoulder dates should be excluded.
   */
  amountDue: number;

  adjustmentType: AdjustmentType;
  description: string;
}




// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/payment-summary/adjustment-summary.ts